<template>
  <el-table :data="tableDatas" size="mini" border :max-height="200">
    <el-table-column type="index" label="No." width="50"></el-table-column>
    <el-table-column prop="eightBitCode" label="Local Number"></el-table-column>
  </el-table>
</template>
<script>
export default {
  name: '',
  props: {
    gridData: {
      type: String
    },
  },
  data() {
    return {
      tableDatas: []
    }
  },
  watch: {
    gridData:{
      handler(newV){
      },
      immediate:true
    }
  },
  created() {
    this.character();
  },
  methods: {
    character() {
      const eightBitCodeStr = this.gridData;
      let arr = [];
      if (eightBitCodeStr && eightBitCodeStr.length > 0) {
        arr = eightBitCodeStr.replace(/(^\s*)|(\s*$)/g, "").split(/[\n,，\s]+/g);
      };
      arr.forEach(item => {
        this.tableDatas.push({
          eightBitCode: item
        })
      })
    }
  },
}
</script>

